import type { PiiClassifierType } from '@repo/api-codegen';

export function formatPiiClassifierType(classifier: PiiClassifierType): string {
	const withSpaces = classifier.replace(/_/g, ' ');
	const lowercased = withSpaces.toLowerCase();
	const sentenceCase = lowercased.charAt(0).toUpperCase() + lowercased.slice(1);
	return `${sentenceCase} found`;
}
